
export const PublicDeliverySeller = new TypedDocumentString(`
    query PublicDeliverySeller($input: InputPublicDeliverySeller!) {
  publicDeliverySeller(input: $input) {
    shipping {
      ...UiSellerDeliveryProductView
      __typename
    }
    locker {
      ...UiSellerDeliveryProductView
      __typename
    }
    location {
      ...UiSellerDeliveryProductView
      __typename
    }
    __typename
  }
}
    fragment UiSellerDeliveryProductView on UiSellerDeliveryProductView {
  id
  title
  type
  courier
  pricingType
  __typename
}`, {"hash":"596863ec4fa4f4f26d9d1d1ac2105b8e8a8cac22f0b57917176dadace60b6150"});